var _excluded = ["loanMinimum", "loanMaximum", "name"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { Input } from '../../elements';
import { payment } from '@futurefamily/ef-utils';

function TreatmentCostInput(_ref) {
  var loanMinimum = _ref.loanMinimum,
      loanMaximum = _ref.loanMaximum,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'cost' : _ref$name,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useFormikContext = useFormikContext(),
      values = _useFormikContext.values,
      setFieldValue = _useFormikContext.setFieldValue;

  useEffect(function () {
    var _values$cost;

    var maxDownPayment = values.cost - loanMinimum;
    var treatmentCost = (_values$cost = values.cost) !== null && _values$cost !== void 0 ? _values$cost : 0;
    var downpayment = payment.getDownpayment(treatmentCost, maxDownPayment, loanMinimum);
    setFieldValue('downpayment', downpayment);
  }, [values.cost, loanMinimum, setFieldValue]);

  var handleKeyPress = function handleKeyPress(e) {
    if (Number.isNaN(parseInt(e.key))) {
      e.preventDefault();
    }

    var inputVal = e.target.value + '' + e.key;

    if (Number(inputVal) > loanMaximum) {
      e.preventDefault();
    }
  };

  return /*#__PURE__*/React.createElement(Input, _extends({}, props, {
    type: "number",
    name: name,
    placeholder: "To start, enter your treatment amount here",
    onKeyPress: handleKeyPress
  }));
}

TreatmentCostInput.propTypes = process.env.NODE_ENV !== "production" ? {
  loanMinimum: PropTypes.number,
  loanMaximum: PropTypes.number,
  name: PropTypes.string
} : {};
export default TreatmentCostInput;